import { CalendarTodayOutlined } from '@material-ui/icons';
import styled, { css } from 'styled-components';

// Estilos do Layout Principal
export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 5px;

  .homeValidityCards {
    width: 100%;
    padding: 0;
  }

  @media (max-width: 665px) {
    flex: 1;
    overflow-y: auto;
    max-height: 100dvh;
    padding-bottom: 100px;
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;

  @media (max-width: 1050px) {
    flex-direction: column;
    align-items: center;
  }
`;

// Estilos do Banner
export const BannerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #4a6cfa;
  color: #ffffff;
  padding: 9px 16px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;

  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
`;

export const BannerText = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 665px) {
    display: none;
  }
`;

export const BannerTitle = styled.h1`
  margin: 0;
  font-size: 18px;
  color: #ffffff;

  span {
    font-size: 24px;
    font-weight: 700;
  }
`;

export const BannerSubtitle = styled.p`
  margin: 4px 0 0;
  font-size: 16px;
  color: #f7d56e;
  line-height: 24px;
  width: 350px;
`;

export const PotencialBloom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 665px) {
    width: 100%;
  }
`;

export const PotencialHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PotencialTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
`;

export const PotencialPercentage = styled.span`
  font-size: 18px;
  font-weight: 700;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const SliderContainer = styled.div`
  width: 100%;
`;

export const SliderTrack = styled.div`
  position: relative;
  width: 260px;
  height: 33px;
  border-radius: 20px;
  border: 4px solid #0b1a8e;
  overflow: visible;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  @media (max-width: 665px) {
    width: 100%;
  }
`;

export const SliderFill = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
`;

export const SliderSection = styled.div`
  flex: ${(props) => props.flex};
  background-color: ${(props) => props.color};

  &:not(:last-child) {
    border-right: 2px solid #0b1a8e;
  }
`;

export const SliderHandle = styled.div`
  width: 10px;
  height: 40px;
  background-color: white;
  border: 2px solid #0b1a8e;
  position: absolute;
  top: -7px;
  z-index: 2;

  left: ${({ percentage }) => `${Math.min(Math.max(percentage, 0), 100)}%`};
  transform: translateX(-50%);
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-around;
  font-size: 16px;
  margin: 8px 5px 0 5px;
  color: white;
  font-weight: bold;
`;

export const Card = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 40%;
  height: 404px;
  border-radius: 12px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  background-color: ${({ variant }) =>
    variant === 'inativo' ? '#E6E7F0' : '#daddf3'};

  border: ${({ variant, color }) =>
    variant === 'inativo' ? 'none' : `4px solid ${color}`};

  @media (max-width: 1050px) {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
  padding-bottom: 12px;
  height: 85px;

  background-color: ${({ variant, color }) =>
    variant === 'inativo' ? '#E6E7F0' : color};

  ${({ variant }) =>
    variant === 'inativo' &&
    css`
      border-bottom: 4px solid #d0d3e2;
      height: 90px;
    `}

  @media (max-width: 665px) {
    width: 100%;
    height: auto;
    flex-wrap: wrap;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  padding-top: 8px;
  gap: 10px;
`;

export const HeaderIconWrapper = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 5px;
  padding-bottom: 10px;

  @media (max-width: 665px) {
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }
`;

export const CardTitle = styled.h2`
  margin: 0;
  width: 104px;
  font-size: 16px;
  font-weight: bold;
  padding-top: 18px;
  color: ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#FFFFFF')};

  @media (max-width: 665px) {
    padding-top: 0;
  }
`;

export const CardMeta = styled.p`
  margin: 0;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #010311;

  .metaLabel {
    color: ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#010311')};

    @media (max-width: 665px) {
      display: none;
    }
  }
`;

export const MetaBadge = styled.span`
  background-color: ${({ variant }) =>
    variant === 'inativo' ? '#D0D3E2' : '#FFFFFF'};

  color: ${({ variant, color }) => (variant === 'inativo' ? '#9296AC' : color)};

  border-radius: 16px;
  font-size: 16px;
  width: 74px;
  height: 20px;
  text-align: center;
  font-weight: bold;

  @media (max-width: 665px) {
    width: 61px;
  }
`;

export const Icon = styled.div`
  color: #6c757d;
  cursor: pointer;
  margin-right: 10px;

  @media (max-width: 665px) {
    margin-bottom: 0;
    margin-right: 5px;
    padding: 10px;
    border-radius: 12px;
    width: 44px;
    height: 44px;

    background-color: #ffffff;

    border: ${({ type }) =>
      type === 'evolucao' ? '2px solid #D0D3E2' : '1px solid #454a67'};

    img {
      height: 22px;
    }
    ${({ disabled }) =>
      disabled &&
      css`
        background: transparent !important;
        border: 2px solid #d0d3e2 !important;
        opacity: 0.6;
        cursor: default;
        margin-top: 5px;
      `}
  }
`;

export const TableWrapper = styled.div`
  overflow-y: auto;
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 95%;
  margin: 10px auto 15px;
  ${({ type }) =>
    type === 'evolucao' &&
    css`
      th,
      td {
        width: 33.33%;
      }
    `}
`;

export const Th = styled.th`
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  border-bottom: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
  text-transform: uppercase;
  padding-bottom: 10px;
  text-align: center;

  color: ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#666770')};

  &:last-child {
    border-right: none;
  }

  &:first-child {
    text-align: left;
  }
`;

export const Td = styled.td`
  font-size: 12px;
  border-bottom: 1px solid #ffffff;
  vertical-align: middle;
  border-right: 1px solid #ffffff;
  text-align: center;
  color: ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#010311')};

  ${({ type }) =>
    type !== 'evolucao' &&
    css`
      padding-top: 10px;
      padding-bottom: 10px;
    `}

  &:last-child {
    border-right: none;
    width: 150px;
    padding-left: 15px;
  }

  &:first-child {
    font-size: 16px;
    text-align: left;
    color: ${({ variant }) => {
      if (variant === 'inativo') {
        return '#9296AC';
      }
      return '#5062f0';
    }};
  }

  tr:last-child & {
    border-bottom: none;
  }
`;

export const StatusBadge = styled.span`
  width: 130px;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: block;
  white-space: nowrap;
  padding-top: 3px;
  padding-bottom: 3px;
  background-color: ${({ status }) => status || 'transparent'};
  color: ${({ status }) => (status ? '#ffffff' : 'inherit')};
`;

export const IconDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
`;

export const DataInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 5px;

  @media (max-width: 665px) {
    margin-top: 5px;
  }
`;

export const DataInputWithIcon = styled.input`
  font-size: 12px;
  width: 68px;
  text-align: center;
  border: none;
  border-bottom: 1px solid
    ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#FFFFFF')};
  padding-left: 16px;
  padding-bottom: 4px;
  background-color: transparent;
  color: ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#FFFFFF')};
  cursor: pointer;
`;

export const DataInputIcon = styled(CalendarTodayOutlined)`
  position: absolute;
  left: 4px;
  font-size: 16px;
  margin-bottom: 4px;
  cursor: pointer;
  color: ${({ variant }) => (variant === 'inativo' ? '#9296AC' : '#FFFFFF')};
`;
